import React from 'react';
import { getPageByIdOrActive } from 'app/stores/selectors';
import { useConnect } from 'app/views/hooks/useConnect';
import { Marker } from './Marker';
export const Spots = (props) => {
    const { slideId } = props;
    const { spots, area } = useConnect(state => ({
        spots: getPageByIdOrActive(state, slideId).spots,
        area: state.viewport.virtual,
    }));
    if (!spots || !spots.length) {
        return null;
    }
    const clipId = 'spots-mask';
    return (React.createElement("g", null,
        React.createElement("defs", null,
            React.createElement("rect", { id: "spot-rect", x: area.x, y: area.y, width: area.width, height: area.height }),
            React.createElement("mask", { id: clipId },
                React.createElement("use", { href: "#spot-rect", fill: "white" }),
                spots.map(id => (React.createElement(Marker, { key: id, id: id }))))),
        React.createElement("use", { href: "#spot-rect", mask: `url(#${clipId})`, fill: "black", fillOpacity: 0.45 })));
};
